import {showToast} from '@/components/Toaster/Toaster';
import * as localizationKeys from '@/consts/localization/localizationKeys';
import {getLocalizedStrings} from '@/services/localization/localizationService';

const showGlobalError = () => {
    // TODO: replace with AEM fragment model
    showToast(getLocalizedStrings()[localizationKeys.GLOBAL_ERROR_NOTIFICATION_TEXT]);
};

export default {
    showGlobalError,
};
